module.exports = __webpack_public_path__ + "static/herohire_logo-13adce6e2f46c7d2cb65026d24b2ad66.png";